import { SaveLocationsDocument } from '~/client/graph/operations/generated/Locations.generated'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import OtherLocation from '~/client/src/shared/models/LocationObjects/OtherLocation'
import ILocationAttributeDto from '~/client/src/shared/types/ILocationAttributeDto'

import LocationAttributesStoreBase from './LocationAttributesBase.store'

/**
 * The catch-all location store: every place whose root kind is project-added or missing,
 * which no kind store would otherwise hold (STX1-597). Empty for a project whose locations
 * all carry one of the twelve root kinds.
 */
export default class OtherLocationsStore extends LocationAttributesStoreBase<OtherLocation> {
  protected saveMutation = SaveLocationsDocument
  protected graphName = 'locations'
  protected defaultIconName = MapViewLocationIcon.Logistics

  public get byId() {
    const { otherLocations } = this.eventsStore.appState
    return otherLocations
  }

  protected fromDto(dto: ILocationAttributeDto): OtherLocation {
    return OtherLocation.fromDto(dto)
  }
}
